import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { useSite } from "../context/SiteContext";

export const Faq = () => {
  const { faqs } = useSite();
  return (
  <section id="faq" data-testid="faq-section" className="border-t border-ink/10">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>Common Questions</Eyebrow>
        <h2 className="font-display text-4xl leading-[1.05] text-ink sm:text-5xl">Frequently Asked Questions</h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible defaultValue="item-0" className="border-t border-ink/15">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-ink/15">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-xl text-ink hover:no-underline sm:text-2xl">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-ink/70">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
  );
};
